module.exports = __webpack_public_path__ + "img/spear.stone.ff7e1678.png";